import { render } from "./GameArea.vue?vue&type=template&id=e2e669d6&scoped=true"
import script from "./GameArea.vue?vue&type=script&lang=js"
export * from "./GameArea.vue?vue&type=script&lang=js"

import "./GameArea.vue?vue&type=style&index=0&id=e2e669d6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2e669d6"]])

export default __exports__